<div class="printable">
  <authority-labs-base-certificate-details
    [order]="order"
    [project]="project"
    [subProject]="subProject"
    [company]="company"
    [contact]="contact"
    [assignee]="assignee"
    [approval]="approval"
    [inspection]="inspection"
    [systemDescription]="'מערכת אוטומטית לכיבוי אש באמצעות גז FM-200.'"
  ></authority-labs-base-certificate-details>

  <div class="page-break"></div>

  <authority-labs-gas-extinguishing-system-test-results
    [inspection]="inspection.inspectionGasExtinguishingSystem"
  >
  </authority-labs-gas-extinguishing-system-test-results>

  <p style="text-align: center">
    <strong style="font-size: 5pt; position: relative; top: -5px"
      >&#10033;</strong
    >
    <strong style="font-size: 14pt">סוף תעודת בדיקה</strong>
    <strong style="font-size: 5pt; position: relative; top: -5px"
      >&#10033;</strong
    >
  </p>
</div>
